/**
 * Effective delivery address of a customer order (decision
 * 2026-09-24-wz-adres-dostawy): the order's „Adres dostawy”
 * (`deliveryLocation`) and, when blank, the customer card address.
 * Mirror of backend `src/utils/orderDeliveryAddress.js`; used for the WZ
 * default and the transport unloading-place prefill/suggestion.
 */
export interface OrderDeliveryAddressSource {
  deliveryLocation?: string | null;
  customer?: { address?: string | null } | null;
}

export function resolveOrderDeliveryAddress(order: OrderDeliveryAddressSource | null | undefined): string {
  const orderAddress = String(order?.deliveryLocation || '').trim();
  return orderAddress || String(order?.customer?.address || '').trim();
}
